import React, {useState} from "react";
import {useParams, useLocation, useNavigate, Navigate} from "react-router-dom";
import {useQuery} from "react-query";
import axios from "axios";
import moment from "moment";
import styled from "styled-components";
import {StatusCard} from "../../../components/StatusCard";
import {EmptyState} from "../../../components/EmptyState";
import PackageDeliveryAlert from "../../../components/PackageDeliveryAlert";
import AppLayout from "../../../layouts/AdminLayout";
import {Dialog, Transition} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {getStatusType} from "../../../utils/status";
import toast from "react-hot-toast";
import {useRoles} from "../../../hooks/useRoles";

export interface OrderData {
  orderId: string;
  orderStatus: string;
  hasPendingTopupRequest: boolean;
  ignoredTopupRequest: boolean;
  TopupRequest: {
    id: string;
    amount: number;
    weightDiff: number;
    orderId: string;
    paid: boolean;
    reason: string;
    type: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  email: string;
  pickUpDetail: {
    fullAddress: string;
    phoneNumber: string;
    senderName: string;
    status: string;
    note: string;
    riderInfo?: {
      fullName: string;
      phoneNumber: string;
    };
    timelines?: Array<{
      event: string;
      entriedAt: string;
    }>;
  };
  deliveryDetails: Array<{
    lat: string;
    long: string;
    fullAddress: string;
    state: string;
    amount: string;
    city: string;
    deliverySchedule: string;
    phoneNumber: string;
    recipientName: string;
    itemWeight: string;
    itemDescription: string;
    refId: string;
    status: string;
    latlng: string;
    additionalDetails: string | null;
    jobId: number;
    trackingLink: string;
    jobToken: string;
    jobHash: string;
    deliveryDate: string;
    deliveredAt: string;
    timezone: string;
    deliveryType: string;
    recipientEmail: string;
    waybillNumber: string;
    note: string;
    recipentEmail: string;
    timelines: Array<{
      event: string;
      entriedAt: string;
    }>;
    riderInfo?: {
      fullName: string;
      phoneNumber: string;
    };
    thirdPartyDispatchInfo?: {
      name: string;
      waybillNumber: string;
    };
  }>;
  deliveryMethod: string;
  jobId: string;
  deliveryType: string;
  estimatedCost: string;
  createdAt: string;
  source: string;
  paymentMode: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    imageUrl: string | null;
    businessName: string | null;
    address: string | null;
    cac: string | null;
    cacDocFileURL: string | null;
    testKey: string | null;
    liveKey: string | null;
    accountType: string;
    email: string;
    phoneNumber: string;
    isVerified: boolean;
    isFlagged: boolean;
    isTrashed: boolean;
    subscriptionPlan: string;
    subscriptionExpires: string;
    allowedDeliveries: string;
    createdAt: string;
    updatedAt: string;
    verifiedAt: string;
    locations: {
      id: string;
      address: string;
      latitude: string | null;
      longitude: string | null;
      city: string | null;
      state: string | null;
      timezone: string | null;
    }[];
    UserSubcription: {
      id: string;
      planId: string;
      remainingCredits: number;
      planDeleted: boolean;
      activatedAt: string;
      userId: string;
      expiresIn: string;
      status: string;
      renewedAt: null;
      cancelledAt: null;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: string;
        name: string;
        amount: number;
        validity: string;
        discount: number | null;
        description: string;
        allowedDeliveries: string;
        baseFee: string | null;
        benefits: string[];
        visible: boolean;
        createdAt: string;
        updatedAt: string;
      };
    };
  };
}

export const OrderDetail = () => {
  const {orderID} = useParams<{orderID: string}>();
  const {scope} = useRoles();
  const location = useLocation();
  const navigate = useNavigate();
  const Baseurl = process.env.REACT_APP_BASEURL;
  const token = JSON.parse(localStorage.getItem("eftd-admin-token") || "{}")
    ?.data?.data?.token;
  const [isLoadingPackage, setIsLoadingPackage] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [isDeliveryStatusOpen, setIsDeliveryStatusOpen] = useState(false);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [isDeliveryStatusUpdating, setIsDeliveryStatusUpdating] =
    useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState("");

  const [isTopupOpen, setIsTopupOpen] = useState(false);
  const [isTopupRequestedOpen, setIsTopupRequestedOpen] = useState(true);
  const [isTopupRejectedOpen, setIsTopupRejectedOpen] = useState(true);
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [isTopupSuccessOpen, setIsTopupSucessOpen] = useState(true);
  const [isRefundOpen, setIsRefundOpen] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState("");
  const [isRemoving, setIsRemoving] = useState(false);
  const [cancellingWaybill, setCancellingWaybil] = useState("");
  const [removingWaybill, setRemovingWaybill] = useState("false");

  const [type, setType] = useState("weight_diff");
  const [newWeightDifference, setNewWeightDifference] = useState("");
  const [reason, setReason] = useState("");

  const handleTopUpAmountChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTopUpAmount(event.target.value);
  };

  const handleNewWeightDifferenceChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setNewWeightDifference(event.target.value);
  };
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  const handlereasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
  };

  const fetchOrder = async () => {
    const response = await axios.get(
      `${Baseurl}/api/admin/orders/${orderID}?page=1&limit=10`,
      config
    );
    return response?.data?.data.items;
  };

  const {
    data: orderData,
    isLoading,
    isRefetching,
    refetch,
  } = useQuery<OrderData>(["ORDER", orderID], fetchOrder, {
    enabled: !!orderID,
    cacheTime: 0,
  });

  const status = orderData
    ? getStatusType(orderData.orderStatus)
    : {title: "", type: ""};

  const firstDeliveryDetail = orderData?.deliveryDetails?.[0] || {
    trackingLink: undefined,
    fullAddress: undefined,
    phoneNumber: undefined,
    recipientName: undefined,
    itemWeight: undefined,
    itemDescription: undefined,
    additionalDetails: undefined,
    deliveryDate: undefined,
    timelines: undefined,
    waybillNumber: undefined,
    status: undefined,
    riderInfo: undefined,
    thirdPartyDispatchInfo: undefined,
    recipentEmail: undefined,
  };
  const pickUpDetail = orderData?.pickUpDetail || {
    fullAddress: undefined,
    phoneNumber: undefined,
    senderName: undefined,
    riderInfo: undefined,
    timelines: undefined,
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const updateOrderStatus = async (status: string) => {
    if (!status) {
      toast.error("Please select a status");
      return;
    }

    setIsStatusUpdating(true);
    try {
      await axios.post(
        `${Baseurl}/api/admin/orders/${orderID}/update/status`,
        {status},
        {
          ...config,
        }
      );
      toast.success("Order status updated successfully");
      setIsStatusOpen(false);
      setSelectedStatus(""); // Reset selection
      refetch();
    } catch (error: any) {
      const errorMessage = error.response?.data?.message;

      if (Array.isArray(errorMessage)) {
        toast.error(errorMessage[0]);
      } else if (typeof errorMessage === "string") {
        toast.error(errorMessage);
      } else {
        toast.error("Failed to update order status");
      }
    } finally {
      setIsStatusUpdating(false);
    }
  };

  const updateDeliveryOrderStatus = async (status: string, refId: string) => {
    if (!status) {
      toast.error("Please select a status");
      return;
    }

    setIsDeliveryStatusUpdating(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/deliveries/${refId}/status`,
        {status},
        {
          ...config,
        }
      );
      toast.success("Order status updated successfully");
      setIsDeliveryStatusOpen(false);
      setSelectedDeliveryStatus(""); // Reset selection
      refetch();
    } catch (error: any) {
      const errorMessage = error.response?.data?.message;

      if (Array.isArray(errorMessage)) {
        toast.error(errorMessage[0]);
      } else if (typeof errorMessage === "string") {
        toast.error(errorMessage);
      } else {
        toast.error("Failed to update order status");
      }
    } finally {
      setIsDeliveryStatusUpdating(false);
    }
  };

  const packagedAtHub = async () => {
    setIsLoadingPackage(true);
    try {
      await axios.post(
        `${Baseurl}/api/admin/orders/${orderID}/update/status`,
        {status: "IN_HUB"},
        {
          ...config,
        }
      );
      refetch();
    } catch (error) {
    } finally {
      setIsLoadingPackage(false);
    }
  };

  const cancelOrder = async () => {
    setIsCancelling(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/cancel`,
        {},
        {
          ...config,
        }
      );
      toast.success("Order Cancelled");
      refetch();
    } catch (error) {
    } finally {
      setIsCancelling(false);
      setIsCancelOpen(false);
    }
  };

  const removeQueueData = async (waybill: string) => {
    setRemovingWaybill(waybill);
    setIsRemoving(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/topups/${waybill}/remove`,
        {},
        {
          ...config,
        }
      );
      refetch();
    } catch (err: any) {
      console.error("Error fetching order details:", err);
    } finally {
      setRemovingWaybill("");
      setIsRemoving(false);
    }
  };

  const cancelQueueData = async (waybill: string) => {
    setCancellingWaybil(waybill);
    setIsCancelling(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/topups/${waybill}/cancel`,
        {},
        {
          ...config,
        }
      );
      refetch();
    } catch (err: any) {
      console.error("Error fetching order details:", err);
    } finally {
      setCancellingWaybil("");
      setIsCancelling(false);
    }
  };

  const processRefund = async () => {
    setIsRequesting(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/items/${firstDeliveryDetail.waybillNumber}/refund/initiate`,
        {},
        {
          ...config,
        }
      );
      refetch();
    } catch (error) {
    } finally {
      setIsRequesting(false);
    }
  };

  const completeRefund = async () => {
    setIsRequesting(true);
    try {
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/items/${firstDeliveryDetail.waybillNumber}/refund/complete`,
        {},
        {
          ...config,
        }
      );
      refetch();
      setIsRefundOpen(false);
    } catch (error) {
    } finally {
      setIsRequesting(false);
    }
  };

  const requestTopup = async () => {
    setIsRequesting(true);
    try {
      const res = await axios.patch(
        `${Baseurl}/api/admin/orders/${orderID}/topups/queue`,
        {
          amount: String(topUpAmount),
          weightDiff:
            type === "weight_diff" || type === "both"
              ? String(newWeightDifference)
              : undefined,
          waybillNumber: orderData?.deliveryDetails[0].waybillNumber,
          type: type,
          reason: type === "reason" || type === "both" ? reason : undefined,
        },
        {
          ...config,
        }
      );
      await axios.post(
        `${Baseurl}/api/admin/orders/${orderID}/topups`,
        {
          queueId: res.data.data.id,
        },
        {
          ...config,
        }
      );
      toast.success("Topup requested");
      refetch();

      setIsOpen(false);
    } catch (error) {
    } finally {
      setIsRequesting(false);
    }
  };
  const deliveryStatus = firstDeliveryDetail
    ? getStatusType(firstDeliveryDetail.status!)
    : {title: "", type: ""};
  return (
    <AppLayout>
      {isLoading ? (
        <div className="p-10 text-center text-gray-500">Loading...</div>
      ) : !orderData ? (
        <EmptyState text="Order not found" type="" />
      ) : (
        <div className="p-5">
          <div className="flex !items-center !justify-between !p-4">
            <button
              className="flex items-center gap-2 !mb-6"
              onClick={() => navigate(-1)}
            >
              <ArrowLeftIcon width={24} height={24} color="#666D80" />
              <p className="!text-sm text-[#666d80]">Go Back</p>
            </button>
            {/* <button>
              <XMarkIcon width={24} height={24} color="#666D80" />
            </button> */}
          </div>

          <div className="flex justify-between items-cented mb-5">
            <h2 className="text-3xl font-bold">Order Details</h2>

            <div className="flex items-center gap-4">
              {(orderData.orderStatus === "IN_HUB" ||
                orderData.orderStatus === "EXECUTING") &&
                //  ||firstDeliveryDetail?.status === "UNASSIGNED"
                scope === "write" && (
                  <HubButton
                    onClick={() => setIsOpen(true)}
                    className="!border !border-[#fe7f1f] !rounded-[10px] !bg-transparent !text-[#fe7f1f] !font-bold !py-3 !px-5 !text-sm"
                  >
                    Request Topup
                  </HubButton>
                )}
              <HubButton
                disabled={isLoadingPackage}
                onClick={() => {
                  navigate(`/orders/receipt/${orderID}`);
                }}
                className="!border !border-[#fe7f1f] !rounded-[10px] !bg-transparent !text-[#fe7f1f] !font-bold !py-3 !px-5 !text-sm"
              >
                View Receipt
              </HubButton>
              <HubButton
                onClick={() => {
                  setIsStatusOpen(true);
                }}
                className="!border !border-[#fe7f1f] !rounded-[10px] !bg-transparent !text-[#fe7f1f] !font-bold !py-3 !px-5 !text-sm"
              >
                Change Status
              </HubButton>
              <HubButton
                onClick={() => {
                  setIsDeliveryStatusOpen(true);
                }}
                className="!border !border-[#fe7f1f] !rounded-[10px] !bg-transparent !text-[#fe7f1f] !font-bold !py-3 !px-5 !text-sm"
              >
                Change Delivery Status
              </HubButton>

              {orderData?.orderStatus === "PACKAGE_AT_HUB" &&
                scope === "write" && (
                  <HubButton
                    disabled={isLoadingPackage}
                    onClick={() => {
                      packagedAtHub();
                    }}
                    className="!bg-[#fe7f1f] !rounded-[10px] !text-white !font-bold !py-3 !px-5 !text-sm"
                  >
                    {isLoadingPackage ? "Loading..." : "Package at Hub"}
                  </HubButton>
                )}
            </div>
          </div>
          {orderData?.hasPendingTopupRequest &&
            !orderData?.TopupRequest?.paid &&
            isTopupRequestedOpen && (
              <div className="!flex !items-center justify-between !gap-3 !w-full !rounded-lg !bg-[#FEF3F2] !p-4 !my-4 !border-l-4 !border-l-[#F04438]">
                <div className="flex items-center gap-3">
                  <ExclamationTriangleIcon
                    className="!w-5 !h-5 !text-[#F04438]"
                    aria-hidden="true"
                  />
                  <p className="!text-[#F04438]">Top up has been requested</p>
                </div>
                {scope === "write" && (
                  <button
                    className="text-xs font-semibold py-2 px-4 border border-[#F04438] rounded-lg !text-[#F04438]"
                    onClick={() => setIsTopupOpen(true)}
                  >
                    View
                  </button>
                )}
              </div>
            )}

          {orderData?.TopupRequest?.paid && isTopupSuccessOpen && (
            <div className="!flex !items-center !justify-between !gap-3 !w-full !rounded-lg !bg-green-600/20 !p-4 !my-4 !border-l-4 !border-green-600">
              <div className="flex items-center gap-3">
                <ExclamationTriangleIcon
                  className="!w-5 !h-5 !text-green-600"
                  aria-hidden="true"
                />
                <p className="!text-green-600">Top up payment successful</p>
              </div>
              <button
                className="text-xs font-semibold !text-green-600"
                onClick={() => setIsTopupSucessOpen(false)}
              >
                Close
              </button>
            </div>
          )}

          {orderData?.ignoredTopupRequest &&
            orderData?.orderStatus === "CANCELLED" &&
            firstDeliveryDetail.status !== "REFUND_INITIATED" &&
            firstDeliveryDetail.status !== "REFUND_COMPLETED" && (
              <div className="!flex !items-center !justify-between !gap-3 !w-full !rounded-lg !bg-[#FEF3F2] !p-4 !my-4 !border-l-4 !border-l-[#F04438]">
                <div className="!flex !items-center  !gap-3">
                  <ExclamationTriangleIcon
                    className="!w-5 !h-5 !text-[#F04438]"
                    aria-hidden="true"
                  />
                  <p className="">Top up has been rejected</p>
                </div>
                {scope === "write" && (
                  <button
                    className="py-4 px-6 rounded-[10px] bg-[#ffeed4] border border-[#fe7f1f] text-[#fe7f1f] font-bold text-sm"
                    onClick={() => processRefund()}
                  >
                    {isRequesting ? "Loading.." : "Process refund"}
                  </button>
                )}
              </div>
            )}

          {orderData?.orderStatus === "CANCELLED" &&
            orderData.pickUpDetail.status === "CANCELLED" && (
              <div className="!flex !items-center !justify-between !gap-3 !w-full !rounded-lg !bg-[#FEF3F2] !p-4 !my-4 !border-l-4 !border-l-[#F04438]">
                <div className="!flex !items-center  !gap-3">
                  <ExclamationTriangleIcon
                    className="!w-5 !h-5 !text-[#F04438]"
                    aria-hidden="true"
                  />
                  <p className="">Order cancelled</p>
                </div>
                {scope === "write" && (
                  <button
                    className="py-4 px-6 rounded-[10px] bg-[#ffeed4] border border-[#fe7f1f] text-[#fe7f1f] font-bold text-sm"
                    onClick={() => processRefund()}
                  >
                    {isRequesting ? "Loading.." : "Process refund"}
                  </button>
                )}
              </div>
            )}

          {orderData?.orderStatus === "DELIVERY_FAILED" && (
            <PackageDeliveryAlert id={orderID!} jobId={orderData?.jobId!} />
          )}

          <OrderHeader>
            <OrderInfo>
              <div>
                <InfoLabel>Order ID:</InfoLabel>
                <OrderId>{orderData?.orderId}</OrderId>
              </div>
              <StatusContainer>
                <StatusCard title={status.title} type={status.type} />
                <RefreshIcon
                  className={`${isRefetching ? "animate-spin" : ""}`}
                  onClick={() => refetch()}
                  src="/refresh.svg"
                  alt="Refresh"
                />
              </StatusContainer>
            </OrderInfo>

            <ActionButtons>
              {firstDeliveryDetail?.trackingLink && (
                <div className="relative w-full overflow-x-auto whitespace-nowrap text-sm text-gray-700 px-3 border border-gray-100 rounded-lg flex items-center gap-4">
                  <span className=" ">
                    Tracking Link:{" "}
                    <strong className="text-black">
                      {firstDeliveryDetail.trackingLink}
                    </strong>
                  </span>
                  <button
                    onClick={() =>
                      copyToClipboard(firstDeliveryDetail.trackingLink!)
                    }
                    className="hover:bg-gray-100 rounded"
                  >
                    <img src="/copy.svg" alt="Copy" className="w-4 h-4" />
                  </button>
                </div>
              )}
              {firstDeliveryDetail?.status === "REFUND_INITIATED" &&
                scope === "write" && (
                  <HubButton
                    disabled={isRequesting}
                    onClick={() => {
                      setIsRefundOpen(true);
                    }}
                    className="!bg-[#fe7f1f] !rounded-[10px] !text-white !font-bold !py-3 !px-4 !min-w-max text-sm"
                  >
                    {isRequesting ? "Loading..." : "Complete Refund"}
                  </HubButton>
                )}
              {(orderData.orderStatus === "IN_HUB" ||
                orderData.orderStatus === "PACKAGE_AT_HUB" ||
                orderData.orderStatus === "PICKUP_SCHEDULED" ||
                orderData.orderStatus === "PROCESSING") &&
                scope === "write" && (
                  <HubButton
                    onClick={() => {
                      setIsCancelOpen(true);
                    }}
                    className="!bg-transparent !border !border-[#fe7f1f] !rounded-[10px] !text-[#fe7f1f] !font-bold !py-3 !px-4 !min-w-max text-sm"
                  >
                    Cancel
                  </HubButton>
                )}
            </ActionButtons>
          </OrderHeader>
          <p className="-my-4 text-sm">
            {orderData.pickUpDetail.note &&
              `Note: ${orderData.pickUpDetail.note}`}
          </p>
          <GridContainer>
            <TrackPackageCard>
              <TrackHeader>
                <img src="/truck.svg" alt="Truck" />
                <p>Track your package delivery</p>
              </TrackHeader>

              <AddressDisplay>
                <AddressTag>
                  {pickUpDetail?.fullAddress?.substring(0, 14) || "N/A"}
                  {(pickUpDetail?.fullAddress?.length ?? 0) > 14 && "..."}
                </AddressTag>
                <DeliveryLine
                  src="/delivery-line-spoke.svg"
                  alt="Delivery line"
                />
                <AddressTag>
                  {firstDeliveryDetail?.fullAddress?.substring(0, 14) || "N/A"}
                  {(firstDeliveryDetail?.fullAddress?.length ?? 0) > 14 &&
                    "..."}
                </AddressTag>
              </AddressDisplay>

              <ProgressBar>
                <ProgressFill
                  width={
                    orderData?.orderStatus === "PROCESSING"
                      ? "15%"
                      : orderData?.orderStatus === "ENROUTE_TO_PICKUP"
                      ? "20%"
                      : orderData?.orderStatus === "PICKEDUP"
                      ? "25%"
                      : orderData?.orderStatus === "PICKUP_FAILED"
                      ? "25%"
                      : orderData?.orderStatus === "PACKAGE_AT_HUB"
                      ? "50%"
                      : orderData?.orderStatus === "IN_HUB"
                      ? "50%"
                      : orderData?.orderStatus === "EXECUTING"
                      ? "75%"
                      : orderData?.orderStatus === "COMPLETED"
                      ? "100%"
                      : "10%"
                  }
                >
                  <DeliveryIcon src="/delivery.svg" alt="Delivery" />
                </ProgressFill>
              </ProgressBar>
            </TrackPackageCard>

            <InfoCard>
              <img src="/time.svg" alt="Time" className="w-6 h-6" />
              <InfoText>
                <InfoLabelSmall>Estimated Arrival</InfoLabelSmall>
                <InfoValue>
                  {firstDeliveryDetail?.deliveryDate
                    ? moment(firstDeliveryDetail.deliveryDate).format(
                        "DD MMM, YYYY"
                      )
                    : "N/A"}
                </InfoValue>
              </InfoText>
            </InfoCard>

            <InfoCard>
              <RiderHeader>
                <img src="/motorcycle.svg" alt="Motorcycle" />
                {/* <ContactButton className="!flex !justify-center !items-center !p-2 !gap-2.5 !ml-auto !text-sm !font-semibold !bg-white !border !border-orange-500 !text-orange-500 !rounded-[35px]">
                  Contact Rider
                </ContactButton> */}
              </RiderHeader>
              <InfoText>
                <InfoLabelSmall>Rider Information</InfoLabelSmall>
                <InfoValue>
                  {firstDeliveryDetail.riderInfo?.fullName ||
                    pickUpDetail.riderInfo?.fullName}
                </InfoValue>
                <InfoValueSmall>
                  {firstDeliveryDetail.riderInfo?.phoneNumber ||
                    pickUpDetail.riderInfo?.phoneNumber}
                </InfoValueSmall>
              </InfoText>
            </InfoCard>
          </GridContainer>
          <div className="flex gap-6">
            <div className="w-1/2 flex flex-col gap-6">
              <DetailCard>
                {orderData.user && (
                  <>
                    <DetailHeader>
                      <DetailTitle>Account Information</DetailTitle>
                    </DetailHeader>
                    <DetailText className="flex gap-1">
                      Account Name:{" "}
                      <DetailTextBold>
                        {orderData?.user?.businessName ||
                          `${orderData.user.firstName} ${orderData.user.lastName}`}
                      </DetailTextBold>
                    </DetailText>
                    <DetailText className="flex gap-1">
                      Account Type:{" "}
                      <DetailTextBold>
                        {orderData?.user?.accountType}
                      </DetailTextBold>
                    </DetailText>
                    <hr className="border-gray-400 my-2 " />
                  </>
                )}

                <DetailHeader>
                  <DetailTitle>Pickup Information</DetailTitle>
                </DetailHeader>
                <DetailContent>
                  <DetailTextBold>{pickUpDetail?.senderName}</DetailTextBold>
                  <DetailText>{pickUpDetail?.fullAddress}</DetailText>
                  <DetailText>{pickUpDetail?.phoneNumber}</DetailText>
                  <DetailText>{orderData?.email || ""}</DetailText>
                  <DetailText>
                    Service Type -{" "}
                    <strong>
                      {orderData?.deliveryMethod === "HUB_AND_SPOKE"
                        ? "Hub and Spoke"
                        : orderData?.deliveryMethod}
                    </strong>
                  </DetailText>
                </DetailContent>
              </DetailCard>
              <DetailCard>
                <div className="flex gap-2 items-center">
                  <DetailTitle>Delivery Information</DetailTitle>
                  <StatusCard
                    title={deliveryStatus.title}
                    type={deliveryStatus.type}
                  />
                </div>
                <DetailContent>
                  <DetailTextBold>
                    {firstDeliveryDetail?.recipientName}
                  </DetailTextBold>
                  <DetailText>{firstDeliveryDetail?.fullAddress}</DetailText>
                  <DetailText>{firstDeliveryDetail?.phoneNumber}</DetailText>
                  <DetailText>
                    {firstDeliveryDetail?.recipentEmail || ""}
                  </DetailText>
                  <p className="text-sm">
                    {orderData.deliveryDetails[0].note &&
                      `Note: ${orderData.deliveryDetails[0].note}`}
                  </p>
                  <DetailDivider />
                  <DetailText>
                    Product Weight -{" "}
                    <strong>{firstDeliveryDetail?.itemWeight}</strong>
                  </DetailText>
                  <DetailText>
                    Delivery Type - <strong>{orderData?.deliveryType}</strong>
                  </DetailText>
                  {orderData.deliveryType === "DOMESTIC" && (
                    <DetailText>
                      Waybill number -{" "}
                      <strong>
                        {firstDeliveryDetail?.waybillNumber || "N/A"}
                      </strong>
                    </DetailText>
                  )}
                  <DetailText>
                    {firstDeliveryDetail?.itemDescription}
                    {firstDeliveryDetail?.additionalDetails &&
                      `(${firstDeliveryDetail.additionalDetails})`}
                  </DetailText>
                  {firstDeliveryDetail.thirdPartyDispatchInfo && (
                    <>
                      <DetailTitle>Dispatch Information</DetailTitle>

                      <DetailText>
                        Dispatch Name:{" "}
                        <strong>
                          {firstDeliveryDetail.thirdPartyDispatchInfo?.name!}
                        </strong>
                      </DetailText>
                      <DetailText>
                        Tracking no:{" "}
                        <strong>
                          {
                            firstDeliveryDetail.thirdPartyDispatchInfo
                              ?.waybillNumber!
                          }
                        </strong>
                      </DetailText>
                    </>
                  )}{" "}
                </DetailContent>
              </DetailCard>
            </div>
            <div className="!py-5 !px-8 !border !border-black/10 !rounded-[10px] w-1/2">
              <p className="!text-sm !text-gray-400 !font-semibold !mb-6">
                Delivery Timeline
              </p>
              {orderData.source !== "WALK_IN" && (
                <>
                  {/* Pickup */}
                  <div className="!flex !justify-between !items-center !mb-7">
                    <div className="!flex !gap-6 !items-center">
                      <div
                        className={`!text-xs !min-w-[90px] ${
                          pickUpDetail?.timelines![0]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p>
                          {moment(
                            pickUpDetail?.timelines![0]?.entriedAt
                          ).format("DD MMM, YYYY") || "D MMM, YYYY"}
                        </p>
                        <p>
                          {moment(
                            pickUpDetail?.timelines![0]?.entriedAt
                          ).format("HH:mm") || "12:00"}
                        </p>
                      </div>
                      <div
                        className={`${
                          pickUpDetail?.timelines![0]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p className="!text-sm">
                          {pickUpDetail?.timelines![0]?.event ||
                            "Assigned Rider"}
                        </p>
                        <p className="!text-[10px] !text-gray-400">
                          {pickUpDetail?.fullAddress}
                        </p>
                      </div>
                    </div>
                    {pickUpDetail?.timelines![0] && (
                      <img src="/tick-success.svg" alt="Success" />
                    )}
                  </div>
                  <div className="!flex !justify-between !items-center !mb-7">
                    <div className="!flex !gap-6 !items-center">
                      <div
                        className={`!text-xs !min-w-[90px] ${
                          pickUpDetail?.timelines![1]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p>
                          {moment(
                            pickUpDetail?.timelines![1]?.entriedAt
                          ).format("DD MMM, YYYY") || "DD MMM, YYYY"}
                        </p>
                        <p>
                          {moment(
                            pickUpDetail?.timelines![1]?.entriedAt
                          ).format("HH:mm") || "12:00"}
                        </p>
                      </div>
                      <div
                        className={`${
                          pickUpDetail?.timelines![1]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p className="!text-sm">
                          {pickUpDetail?.timelines![1]?.event ||
                            "Rider enroute to pickup package"}
                        </p>
                        <p className="!text-[10px] !text-gray-400">
                          {pickUpDetail?.fullAddress}
                        </p>
                      </div>
                    </div>
                    {pickUpDetail?.timelines![1] && (
                      <img
                        src={
                          pickUpDetail?.timelines![1].event.includes("failed")
                            ? "/tick-failed.svg"
                            : "/tick-success.svg"
                        }
                        alt=""
                      />
                    )}
                  </div>
                  <div className="!flex !justify-between !items-center !mb-7">
                    <div className="!flex !gap-6 !items-center">
                      <div
                        className={`!text-xs !min-w-[90px] ${
                          pickUpDetail?.timelines![2]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p>
                          {moment(
                            pickUpDetail?.timelines![2]?.entriedAt
                          ).format("DD MMM, YYYY") || "D MMM, YYYY"}
                        </p>
                        <p>
                          {moment(
                            pickUpDetail?.timelines![2]?.entriedAt
                          ).format("HH:mm") || "12:00"}
                        </p>
                      </div>
                      <div
                        className={`${
                          pickUpDetail?.timelines![2]
                            ? "!text-gray-700"
                            : "!text-gray-200"
                        }  !font-semibold `}
                      >
                        <p className="!text-sm">
                          {pickUpDetail?.timelines![2]?.event ||
                            "Rider picked up package"}
                        </p>
                        <p className="!text-[10px] !text-gray-400">
                          {pickUpDetail?.fullAddress}
                        </p>
                      </div>
                    </div>
                    {pickUpDetail?.timelines![2] && (
                      <img
                        src={
                          pickUpDetail?.timelines![2].event.includes("failed")
                            ? "/tick-failed.svg"
                            : "/tick-success.svg"
                        }
                        alt=""
                      />
                    )}
                  </div>
                </>
              )}
              {/* Delivery */}
              {[0, 1, 2].map((step) => {
                const timeline = firstDeliveryDetail?.timelines?.[step];
                const isFailed =
                  step === 2 && timeline?.event?.includes("failed");

                return (
                  <div
                    className="!flex !justify-between !items-center !mb-7"
                    key={`delivery-step-${step}`}
                  >
                    <div className="!flex !gap-6 !items-center">
                      <div
                        className={`!text-xs !min-w-[90px] ${
                          timeline ? "!text-gray-700" : "!text-gray-200"
                        } !font-semibold`}
                      >
                        <p>
                          {timeline?.entriedAt
                            ? moment(timeline.entriedAt).format("DD MMM, YYYY")
                            : "D MMM, YYYY"}
                        </p>
                        <p>
                          {timeline?.entriedAt
                            ? moment(timeline.entriedAt).format("HH:mm")
                            : "12:00"}
                        </p>
                      </div>
                      <div
                        className={`${
                          timeline ? "!text-gray-700" : "!text-gray-200"
                        } !font-semibold`}
                      >
                        <p className="!text-sm">
                          {timeline?.event ||
                            (step === 0
                              ? "Rider enroute to delivery location"
                              : step === 1
                              ? "Rider at drop-off location"
                              : "Package delivered")}
                        </p>
                        <p className="!text-[10px] !text-gray-400">
                          {firstDeliveryDetail?.fullAddress || ""}
                        </p>
                      </div>
                    </div>
                    {timeline && (
                      <img
                        src={
                          isFailed ? "/tick-failed.svg" : "/tick-success.svg"
                        }
                        alt={isFailed ? "Failed" : "Success"}
                      />
                    )}
                  </div>
                );
              })}
              {/* Additional delivery timelines if they exist */}
              {firstDeliveryDetail.timelines &&
                firstDeliveryDetail?.timelines?.length > 3 &&
                firstDeliveryDetail.timelines.slice(3).map((timeline, idx) => {
                  const isFailed = timeline.event?.includes("failed");

                  return (
                    <div
                      className="!flex !justify-between !items-center !mb-7"
                      key={`additional-delivery-${idx}`}
                    >
                      <div className="!flex !gap-6 !items-center">
                        <div className="!text-xs !min-w-[90px] !text-gray-700 !font-semibold">
                          <p>
                            {moment(timeline.entriedAt).format("DD MMM, YYYY")}
                          </p>
                          <p>{moment(timeline.entriedAt).format("HH:mm")}</p>
                        </div>
                        <div className="!text-gray-700 !font-semibold">
                          <p className="!text-sm">{timeline.event}</p>
                          <p className="!text-[10px] !text-gray-400">
                            {firstDeliveryDetail?.fullAddress || ""}
                          </p>
                        </div>
                      </div>
                      <img
                        src={
                          isFailed ? "/tick-failed.svg" : "/tick-success.svg"
                        }
                        alt={isFailed ? "Failed" : "Success"}
                      />
                    </div>
                  );
                })}
            </div>
          </div>

          <Transition appear show={isTopupOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsTopupOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-center p-4">
                  <div className="pointer-events-none flex max-w-[513px] h-[370px] overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md flex flex-col justify-between overflow-hidden">
                        <div className="flex justify-between items-start border-b border-b-gray-200">
                          <div className="!p-6">
                            <div className="flex items-center justify-between">
                              <p className="!text-xl !font-bold !text-[#272835]">
                                Topup Request
                              </p>
                            </div>
                            <p className="mt-2 !text-sm text-gray-400">
                              See delivery that require Top up
                            </p>
                          </div>
                          <button
                            className="p-6"
                            onClick={() => setIsTopupOpen(false)}
                          >
                            <XMarkIcon
                              className="w-6 h-6 text-gray-500"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                        <div className="grow overflow-y-auto p-6">
                          <>
                            <div className="space-y-4 my-4">
                              <div className="p-4 rounded-[10px] border border-gray-400 relative flex items-center justify-between">
                                {/* Left content */}
                                <div>
                                  <p className="text-sm font-semibold">
                                    Waybill No:{" "}
                                    {orderData.deliveryDetails[0].waybillNumber}
                                  </p>
                                  <p className="text-xs text-[#666d80] font-semibold mt-1">
                                    {orderData.TopupRequest?.weightDiff && (
                                      <span className="mr-4">
                                        Extra weight -{" "}
                                        {orderData.TopupRequest?.weightDiff}kg
                                      </span>
                                    )}
                                    {orderData.TopupRequest?.amount && (
                                      <span className="">
                                        Amount - N
                                        {orderData?.TopupRequest.amount.toLocaleString() ||
                                          ""}
                                      </span>
                                    )}
                                  </p>
                                  {orderData.TopupRequest?.reason && (
                                    <p className="text-xs text-[#666d80] font-semibold mt-1">
                                      Reason: {orderData.TopupRequest?.reason}
                                    </p>
                                  )}
                                </div>

                                {/* Right buttons */}
                                <div className="flex flex-col gap-2">
                                  <button
                                    onClick={() =>
                                      removeQueueData(
                                        orderData.deliveryDetails[0]
                                          .waybillNumber
                                      )
                                    }
                                    className="text-xs font-medium text-[#2f80ed] border border-[#2f80ed] bg-[#e6f0ff] py-1.5 px-3 rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#2f80ed] focus:ring-opacity-50 disabled:cursor-not-allowed"
                                    disabled={isRemoving}
                                  >
                                    {isRemoving &&
                                    removingWaybill ===
                                      orderData.deliveryDetails[0].waybillNumber
                                      ? "Removing"
                                      : "Remove"}
                                  </button>

                                  <button
                                    onClick={() =>
                                      cancelQueueData(
                                        orderData.deliveryDetails[0]
                                          .waybillNumber
                                      )
                                    }
                                    className="text-xs font-medium text-[#df1c41] bg-[#fff0f3] py-1.5 px-3 rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#df1c41] focus:ring-opacity-50 border border-red-500 disabled:cursor-not-allowed"
                                    disabled={isCancelling}
                                  >
                                    {isCancelling &&
                                    cancellingWaybill ===
                                      orderData.deliveryDetails[0].waybillNumber
                                      ? "Cancelling"
                                      : "Cancel"}
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* <p className="text-sm font-medium text-[#666]">
                              Total Weight:{" "}
                              <span className="font-bold text-black text-lg">
                                {totalWeight}kg
                              </span>
                              <br />
                              Total Amount:{" "}
                              <span className="font-bold text-black text-lg">
                                N{orderData?.TopupRequest?.amount.toLocaleString() || ""}
                              </span>
                            </p> */}
                          </>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>

          <Transition appear show={isOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-end p-4">
                  <div className="pointer-events-none flex max-w-[513px] h-full overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md flex flex-col justify-between overflow-hidden">
                        <div className="!p-6">
                          <div className="flex items-center justify-between">
                            <p className="!text-xl !font-bold !text-[#272835]">
                              Request Top Up
                            </p>
                          </div>
                          <p className="mt-2 !text-sm text-gray-400">
                            Provide details about top up request
                          </p>
                          <div className="!mt-4">
                            <div>
                              <p className="!text-gray-600 !text-sm !mb-2">
                                Type
                              </p>
                              <select
                                name="type"
                                id="type"
                                onChange={(
                                  e: React.ChangeEvent<
                                    | HTMLInputElement
                                    | HTMLSelectElement
                                    | HTMLTextAreaElement
                                  >
                                ) => {
                                  setType(e.target.value);
                                }}
                                className="!h-[50px] !border !border-[#dfe1e7] !py-2 !px-3 !rounded-[10px] !w-full mb-4"
                              >
                                <option value="weight_diff">
                                  Weight Difference
                                </option>
                                <option value="reason">Miscellaneous </option>
                                <option value="both">Both</option>
                              </select>
                            </div>

                            <div>
                              <p className="!text-gray-600 !text-sm !mb-2">
                                Top Up Amount
                              </p>
                              <input
                                type="text"
                                name="topUpAmount"
                                id="topUpAmount"
                                placeholder="Enter amount here"
                                className="!h-[50px] !border !border-[#dfe1e7] !py-4 !px-6 !rounded-[10px] !w-full mb-4"
                                value={topUpAmount}
                                onChange={handleTopUpAmountChange}
                              />
                            </div>
                            {(type === "weight_diff" || type === "both") && (
                              <div>
                                <p className="!text-gray-600 !text-sm !mb-2">
                                  New Weight Difference
                                </p>
                                <input
                                  type="number"
                                  name="newWeightDifference"
                                  id="newWeightDifference"
                                  placeholder="Enter weight here"
                                  className="!h-[50px] !border !border-[#dfe1e7] !py-4 !px-6 !rounded-[10px] !w-full mb-4"
                                  value={newWeightDifference}
                                  onChange={handleNewWeightDifferenceChange}
                                />
                              </div>
                            )}
                            {(type === "reason" || type === "both") && (
                              <div>
                                <p className="!text-gray-600 !text-sm !mb-2">
                                  Reason
                                </p>
                                <input
                                  type="text"
                                  name="reason"
                                  id="reason"
                                  placeholder="Enter reason"
                                  className="!h-[50px] !border !border-[#dfe1e7] !py-4 !px-6 !rounded-[10px] !w-full mb-4"
                                  value={reason}
                                  onChange={handlereasonChange}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Header */}
                        <div className="flex items-center !gap-4 justify-between !p-6">
                          <button
                            onClick={() => setIsOpen(false)}
                            className="!bg-[#fff0f3] !rounded-[10px] !font-bold !py-4 !px-[41px] !flex !items-center !justify-center !text-[#FF3B30]"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => requestTopup()}
                            className="!bg-[#FE7F1F] !rounded-[10px] !font-bold !py-4 !px-[18px] !flex !items-center !justify-center !text-white"
                          >
                            {isRequesting ? "Loading..." : "Send Request"}
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>
          <Transition appear show={isRefundOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsRefundOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-center p-4">
                  <div className="pointer-events-none flex max-w-[424px] overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto max-w-[424px] w-full overflow-hidden p-7">
                        <div className="flex justify-end mb-4">
                          <button onClick={() => setIsRefundOpen(false)}>
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.757289 11.2426L5.99993 6M11.2426 0.75736L5.99993 6M5.99993 6L0.757289 0.75736M5.99993 6L11.2426 11.2426"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>

                        <div className="flex justify-center">
                          <svg
                            width="81"
                            height="80"
                            viewBox="0 0 81 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M32.5537 12.1398C36.0784 6.01004 44.9224 6.01002 48.447 12.1398L75.2568 58.7656C78.7707 64.8767 74.3595 72.5016 67.3102 72.5016H13.6905C6.64124 72.5016 2.23002 64.8767 5.7439 58.7656L32.5537 12.1398ZM40.5 27.5C41.8807 27.5 43 28.6193 43 30V43.3333C43 44.714 41.8807 45.8333 40.5 45.8333C39.1193 45.8333 38 44.714 38 43.3333V30C38 28.6193 39.1193 27.5 40.5 27.5ZM42.3916 58.336C43.3152 57.3097 43.232 55.729 42.2058 54.8054C41.1795 53.8817 39.5988 53.9649 38.6751 54.9912L38.6418 55.0282C37.7181 56.0545 37.8013 57.6352 38.8276 58.5589C39.8539 59.4825 41.4346 59.3993 42.3583 58.373L42.3916 58.336Z"
                              fill="#FF9638"
                            />
                          </svg>
                        </div>

                        <p className="my-4 text-[28px] font-semibold text-[#36394a] text-center">
                          Complete Refunds?
                        </p>

                        <p className="text-sm text-center text-[#818898]">
                          Are you sure this customer has been refunded? This is
                          an irreversible action.
                        </p>
                        {/* Header */}
                        <div className="flex items-center !gap-4 justify-between !py-6">
                          <button
                            onClick={() => setIsRefundOpen(false)}
                            className="!bg-transparent !rounded-[10px] !font-bold !py-4 !w-1/2 !flex !items-center !justify-center !text-[#FE7F1F] border border-[#FE7F1F]"
                          >
                            No
                          </button>
                          <button
                            onClick={() => completeRefund()}
                            className="!bg-[#FE7F1F] !rounded-[10px] !font-bold !py-4 !w-1/2 !flex !items-center !justify-center !text-white"
                          >
                            {isRequesting ? "Loading..." : "Yes"}
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>

          <Transition appear show={isCancelOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsCancelOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-center p-4">
                  <div className="pointer-events-none flex max-w-[513px] h-max overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md flex flex-col justify-between overflow-hidden">
                        <div className="!p-6">
                          <p className="!text-xl !font-bold !text-[#272835] text-center">
                            Cancel Order
                          </p>
                          <p className="mt-2 !text-sm text-gray-400 text-center">
                            Are you sure you want to cancel order
                          </p>
                        </div>
                        {/* Header */}
                        <div className="flex items-center !gap-4 justify-between !p-6">
                          <button
                            onClick={() => cancelOrder()}
                            className="!bg-[#FE7F1F] !rounded-[10px] !font-bold !py-4 !px-[18px] !flex !items-center !justify-center !text-white w-1/2"
                          >
                            {isCancelling ? "Cancelling..." : "Yes, Cancel"}
                          </button>
                          <button
                            onClick={() => setIsCancelOpen(false)}
                            className="border !border-[#FF3B30] !rounded-[10px] !font-bold !py-4 !px-[41px] !flex !items-center !justify-center !text-[#FF3B30] w-1/2"
                          >
                            No
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>

          <Transition appear show={isStatusOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsStatusOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-center p-4">
                  <div className="pointer-events-none flex max-w-[513px] h-max overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md flex flex-col justify-between overflow-hidden">
                        <div className="!p-6">
                          <p className="!text-xl !font-bold !text-[#272835] text-center">
                            Change Order Status
                          </p>
                        </div>

                        <div className="!px-6 !pb-6">
                          <select
                            className="select w-full px-3 border border-gray-300 rounded-[10px] focus:border-orange-500 focus:ring-orange-500 text-sm"
                            onChange={(e) => setSelectedStatus(e.target.value)}
                            value={selectedStatus}
                          >
                            <option value="">Select Status</option>
                            <option value="IN_HUB">In hub</option>
                            <option value="EXECUTING">Executing</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="CANCELLED">Cancelled</option>
                            <option value="PICKUP_FAILED">
                              Pick up Failed
                            </option>
                            <option value="PROCESSING">Processing</option>
                            <option value="PICKUP_SCHEDULED">
                              Pick up Scheduled
                            </option>
                          </select>
                        </div>

                        <div className="flex items-center !gap-4 justify-between !p-6">
                          <button
                            onClick={() => updateOrderStatus(selectedStatus)}
                            disabled={!selectedStatus || isStatusUpdating}
                            className="!bg-[#FE7F1F] !rounded-[10px] !font-bold !py-4 !px-[18px] !flex !items-center !justify-center !text-white w-1/2 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {isStatusUpdating ? "Updating..." : "Update Status"}
                          </button>
                          <button
                            onClick={() => setIsStatusOpen(false)}
                            className="border !border-[#FF3B30] !rounded-[10px] !font-bold !py-4 !px-[41px] !flex !items-center !justify-center !text-[#FF3B30] w-1/2"
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>

          <Transition appear show={isDeliveryStatusOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setIsDeliveryStatusOpen(false)}
            >
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden flex items-center justify-center p-4">
                  <div className="pointer-events-none flex max-w-[513px] h-max overflow-y-auto !rounded-[20px] overflow-hidden bg-white">
                    <Transition.Child
                      as={React.Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md flex flex-col justify-between overflow-hidden">
                        <div className="!p-6">
                          <p className="!text-xl !font-bold !text-[#272835] text-center">
                            Change Delivery Status
                          </p>
                        </div>

                        <div className="!px-6 !pb-6">
                          <select
                            className="select w-full px-3 border border-gray-300 rounded-[10px] focus:border-orange-500 focus:ring-orange-500 text-sm"
                            onChange={(e) =>
                              setSelectedDeliveryStatus(e.target.value)
                            }
                            value={selectedDeliveryStatus}
                          >
                            <option value="">Select Status</option>
                            <option value="ASSIGNED">Assigned</option>
                            <option value="UNASSIGNED">Unassigned</option>
                            <option value="DELIVERED">Delivered</option>
                            <option value="FAILED">Failed</option>
                            <option value="PICKEDUP">Picked Up</option>
                            <option value="IN_TRANSIT">In Transit</option>
                            <option value="TOPUP_REQUESTED">
                              Top up Requested
                            </option>
                            <option value="REFUND_INITIATED">
                              Refund Initiated
                            </option>
                            <option value="REFUND_COMPLETED">
                              Refund Completed
                            </option>
                          </select>
                        </div>

                        <div className="flex items-center !gap-4 justify-between !p-6">
                          <button
                            onClick={() =>
                              updateDeliveryOrderStatus(
                                selectedDeliveryStatus,
                                orderData.deliveryDetails[0].refId
                              )
                            }
                            disabled={
                              !selectedDeliveryStatus ||
                              isDeliveryStatusUpdating
                            }
                            className="!bg-[#FE7F1F] !rounded-[10px] !font-bold !py-4 !px-[18px] !flex !items-center !justify-center !text-white w-1/2 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {isDeliveryStatusUpdating
                              ? "Updating..."
                              : "Update Status"}
                          </button>
                          <button
                            onClick={() => setIsDeliveryStatusOpen(false)}
                            className="border !border-[#FF3B30] !rounded-[10px] !font-bold !py-4 !px-[41px] !flex !items-center !justify-center !text-[#FF3B30] w-1/2"
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
      )}
    </AppLayout>
  );
};

const OrderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const OrderInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 40px;
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RefreshIcon = styled.img`
  margin-top: 4px;
`;

const InfoLabel = styled.span`
  font-size: 14px;
  color: #818898;
`;

const OrderId = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #272835;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const TrackingLink = styled.div`
  padding: 14px 20px;
  border: 1px solid #eceff3;
  border-radius: 35px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #a4acb9;
  overflow: hidden;
  max-height: 60px;

  strong {
    color: #666d80;
    font-weight: 600;
  }
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const HubButton = styled.button`
  padding: 16px 28px;
  background: #fe7f1f;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  border: none;
  cursor: pointer;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin: 48px 0 24px;
`;

const TrackPackageCard = styled.div`
  background-color: #f4f6fa;
  border-radius: 10px;
  padding: 24px;
  grid-column: span 2;
`;

const TrackHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 40px;

  p {
    color: #666d80;
    font-weight: 600;
  }
`;

const AddressDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const AddressTag = styled.p`
  color: white;
  font-size: 11px;
  font-weight: 600;
  background-color: black;
  padding: 8px 20px;
  border-radius: 35px;
  white-space: nowrap;
`;

const DeliveryLine = styled.img`
  max-width: 190px;
  transform: scale(0.83);
`;

const ProgressBar = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 10px;
  height: 8px;
  display: flex;
  align-items: center;
  padding: 0 2px;
`;

const ProgressFill = styled.div<{width: string}>`
  background-color: #31eaf4;
  height: 4px;
  border-radius: 10px;
  position: relative;
  width: ${(props) => props.width};
`;

const DeliveryIcon = styled.img`
  position: absolute;
  bottom: -4px;
  right: 0;
`;

const InfoCard = styled.div`
  padding: 32px 24px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InfoLabelSmall = styled.p`
  font-size: 12px;
  color: #818898;
`;

const InfoValue = styled.p`
  font-size: 18px;
  color: #272835;
  font-weight: 600;
`;

const InfoValueSmall = styled.p`
  font-size: 10px;
  color: #818898;
`;

const RiderHeader = styled.div`
  display: flex;
  align-items: center;
`;

const ContactButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 10px;
  margin-left: auto;
  font-size: 14px;
  font-weight: 600;
  background: #ffffff;
  border: 1px solid #fe7f1f;
  color: #fe7f1f;
  border-radius: 35px;
  cursor: pointer;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 24px;
`;

const DetailCard = styled.div`
  padding: 20px 32px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

const TimelineCard = styled(DetailCard)`
  grid-row: span 2;
`;

const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const DetailTitle = styled.p`
  font-size: 14px;
  color: #818898;
  font-weight: 600;
`;

const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailText = styled.p`
  font-size: 14px;
  color: #272835;
  margin-bottom: 4px;
`;

const DetailTextBold = styled(DetailText)`
  font-weight: 700;
`;

const DetailDivider = styled.div`
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

const TimelineItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
`;

const TimelineDate = styled.div`
  font-size: 12px;
  color: #272835;
  font-weight: 600;
`;

const TimelineEvent = styled.div`
  color: #272835;
  font-weight: 600;

  p {
    font-size: 14px;
  }

  small {
    font-size: 10px;
    color: #818898;
  }
`;
